var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertTriangleFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.68444 23C8.23228 23 7.0068 22.0403 6.62124 20.7272C6.45665 20.1667 6.65888 19.5829 6.96821 19.0858L12.2838 9.50096C13.5292 7.49968 16.4708 7.49968 17.7162 9.50096L23.0318 19.0858C23.3411 19.5829 23.5434 20.1667 23.3788 20.7272C22.9932 22.0403 21.7677 23 20.3156 23H9.68444Z",
    fill: "#F6A723",
    stroke: "#F6A723",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 16.3444V12.1392M15 19.4613V19.4983",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangleFilled);
export default __webpack_public_path__ + "static/media/alert-triangle-filled.a1d2cbcd1b7de065f9c6d68e2f05ee73.svg";
export { ForwardRef as ReactComponent };